import { Redirect, Switch, Route } from "react-router-dom";
import { FleetPage } from "pages/FleetPage";

export const FleetRoutes = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/fleet" component={FleetPage} />

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/fleet" from="/pages/fleet" />
      <Redirect to="/pages" />
    </Switch>
  );
};
